import { useUserStore } from '@/stores/user'
import Vue        from 'vue'
import VueRouter  from 'vue-router'
import menu       from '@/confnav' // menu + routes
import { TokenService } from '@/services/storage'
//import { cacheData } from "@/stores/cache.module"
import { pinia } from '@/main'
import { scopeCredential } from "@/scopeCredential"

/**************** Routeur  *********************/
Vue.use(VueRouter)
const router = new VueRouter({
  mode: 'history',
//  base: __dirname,
  routes: menu.routes
})
/**************** Authentification ******************/
router.beforeEach((to, from, next) => {
  const isPublic          = to.matched.some(record => record.meta.public)
  const onlyWhenLoggedOut = to.matched.some(record => record.meta.onlyWhenLoggedOut)
  const loggedIn          = !!TokenService.getToken();

  // old link compatibility
  if (window.location.hash.includes('/magiclink/')) {
    const token = window.location.hash.split('/magiclink/')[1];
    next({ name: 'magiclink', params: { token } });
  }

  if (!isPublic && !loggedIn) {
    return next({ path:'/login', query: {redirect: to.fullPath} })  // Store the full path to redirect the user to after login
  }
  if (loggedIn && onlyWhenLoggedOut) {
    return next('/') // Do not allow user to visit login page or register page if they are logged in
  }
  if( scopeCredential[to.name] !== undefined && ( scopeCredential[to.name]['read'] !== undefined || scopeCredential[to.name]['edit'] !== undefined ) ){
    scopeCredential[to.name]['edit'] = scopeCredential[to.name]['edit'] || []
    scopeCredential[to.name]['read'] = scopeCredential[to.name]['read'] || []
    
    const userStore = useUserStore(pinia)
    let read = scopeCredential[to.name]['read'].indexOf( userStore.me.role )
    let edit = scopeCredential[to.name]['edit'].indexOf( userStore.me.role )

    if( read < 0 && edit < 0 ){
      return next('/forbidden')
    }
  }

  next()

})

export default router